import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import UI_Header from '../components/UI_Header';
import UI_Ribbon_Main from '../components/UI_Ribbon_Main';
import UI_NavigationRail from '../components/ERUMAUI/UI_NavigationRail';
import ContextProviderAccountManagementSelectedAccount from '../Contexts/Context_AccountManagement_SelectedAccount';
import ContextProviderAccountManagementRefreshList from '../Contexts/Context_AccountManagement_RefreshList';
import { useAccounts } from '../Contexts/Context_Accounts';
import { useProperties } from '../Contexts/Context_App_Properties';
import UI_Subwindows from '../components/UI_Subwindows';
import { Context_UI } from '../Contexts/Context_UI';
import Context_Provider_Templating from '../Contexts/Context_Templating';
import Context_Provider_Accounts from '../Contexts/Context_Accounts';
import Context_Provider_MapRenderer from '../Contexts/Context_MapRenderer';
import Context_Provider_ScheduleManagement from '../Contexts/Context_ScheduleManagement';
import { useStatus } from '../Contexts/Context_Status_Global';

import Panel_Map_Left from '../components/InteractiveMap/Panel_Map_Left';
import Panel_Home_Center from '../components/Home/Panel_Home_Center';
import Panel_Home_Right from '../components/Home/Panel_Home_Right';
import Panel_AccountManagement_Center from '../components/AccountManagement/Panel_AccountManagement_Center'
import Panel_Map_Center from '../components/InteractiveMap/Panel_Map_Center';
import Panel_Map_Right from '../components/InteractiveMap/Panel_Map_Right';
import Panel_Templating_Center from '../components/Templating/Panel_Templating_Center';
import Panel_ScheduleManagement_Center from '../components/ScheduleManagement/Panel_ScheduleManagement_Center';
import Panel_ScheduleManagement_Right from '../components/ScheduleManagement/Panel_ScheduleManagement_Right';
import UI_Slide_Manager from '../components/ERUMAUI/UI_Slide_Manager';
import UI_Icon from '../components/ERUMAUI/UI_Icons';

import Icon_Home from '../Assets/Icons/Icon_Home.png';
import Icon_Map from '../Assets/Icons/Icon_Map.png';


export default function DR_Main() {
    const UI = useContext(Context_UI);
    const navigate = useNavigate();
    const location = useLocation();
    const { Slide_Switch } = useStatus();

    useEffect(() => {
        UI.Page_Navigator_Set(navigate);
        // UI.Initialize();
        UI.LoadingScreen_Hide("Screen_Loading");

    }, []);

    useEffect(() => {

    }, [location.pathname]);

    // Match Slide_ID with a slide property on App_Properties.
    const [Composition_Slide, Composition_Slide_Set] = useState([
        {
            Slide_ID: "Home",
            Panel_Left: null,
            Panel_Center: <Panel_Home_Center />,
            Panel_Right: <Panel_Home_Right />,
            Ribbon: {
                Active: true,
                Contents: [
                    {
                        Icon: Icon_Home,
                        Text: "Test",
                        Destination: "/test/home/test",
                        Action: null,
                        Active: true
                    },
                    {
                        Icon: Icon_Home,
                        Text: "Test",
                        Destination: "/test/home/test",
                        Action: null,
                        Active: true
                    }
                ]
            }
        },
        {
            Slide_ID: "Map",
            Panel_Left: <Panel_Map_Left />,
            Panel_Center: <Panel_Map_Center />,
            Panel_Right: <Panel_Map_Right />,
            Ribbon: {
                Active: false,
                Contents: [
                    {
                        Icon: Icon_Home,
                        Text: "Test",
                        Destination: "/test/home/test",
                        Action: null,
                        Active: true
                    },
                    {
                        Icon: Icon_Home,
                        Text: "Test",
                        Destination: "/test/home/test",
                        Action: null,
                        Active: true
                    }
                ]
            }
        }
    ]);

    // Applies to the entire page
    const [Composition_Navigation, Composition_Navigation_Set] = useState([
        {
            Routes: ["/test/home"],
            Destination: "/test/home",
            Icon: Icon_Home,
            Text: "Home",
            hasBadge: false,
            LoadingScreen: false,
            Active: true
        },
        {
            Routes: ["/test/map"],
            Destination: "/test/map",
            Icon: Icon_Home,
            Text: "Interactive Map",
            hasBadge: false,
            LoadingScreen: false,
            Active: true
        }
    ]);

    return (

        <ui-main>
            <Context_Provider_Templating>
                <Context_Provider_Accounts>
                    <Context_Provider_MapRenderer>
                        <Context_Provider_ScheduleManagement>
                            <UI_Subwindows />
                            <UI_Header />
                            <UI_NavigationRail Composition={Composition_Navigation} />
                            <ContextProviderAccountManagementSelectedAccount>
                                <ContextProviderAccountManagementRefreshList>
                                    <UI_Slide_Manager Composition={Composition_Slide} />
                                </ContextProviderAccountManagementRefreshList>
                            </ContextProviderAccountManagementSelectedAccount>
                        </Context_Provider_ScheduleManagement>
                    </Context_Provider_MapRenderer>
                </Context_Provider_Accounts>
            </Context_Provider_Templating>

        </ui-main>



    )
}